<template>
  <div>
    <div class="uk-container uk-margin-small-top">
      <h2 class="uk-heading-small uk-text-center">Confirm Your Information</h2>
      <p
        class="uk-text-center uk-width-1-2@m uk-align-center"
      >Confirm the information you have provided before you submit.</p>
      <progress class="uk-progress uk-width-1-2@m uk-align-center" :value="4" :max="4"></progress>
    </div>
    <div class="uk-container uk-container-small uk-margin-small-top">
      <h3>
        Basic Info
        <router-link to="/new-project/ind">
          <span uk-icon="icon: pencil; ratio: 1.5" class="uk-float-right"></span>
        </router-link>
      </h3>
      <p class="uk-margin-remove-top">
        <strong>First Name:</strong>
        {{info.basicInfo.fName}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Last Name:</strong>
        {{info.basicInfo.lName}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Email:</strong>
        {{info.basicInfo.email}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Phone:</strong>
        {{info.basicInfo.phone}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Company:</strong>
        {{info.basicInfo.company}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Interested Products:</strong>
        {{interestedProducts}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Deadline:</strong>
        {{info.basicInfo.deadline}}
      </p>
      <p class="uk-margin-remove-top">
        <strong>Design Ideas:</strong>
        {{info.basicInfo.designIdeas}}
      </p>

      <h3>
        Colors
        <router-link to="/new-project/ind/select-colors">
          <span uk-icon="icon: pencil; ratio: 1.5" class="uk-float-right"></span>
        </router-link>
      </h3>
      <div class="uk-grid uk-child-width-1-2 uk-child-width-1-3@m" uk-grid>
        <div v-for="color in info.colors">
          <div>
            <div class="data-uk-card uk-card-default uk-card-small uk-width-1-1" id="card">
              <div class="uk-card-media-top">
                <svg viewBox="0 0 100 52">
                  <title>square</title>
                  <rect width="100" height="52" fill="123456" v-bind:style="{ fill: color.hex }" />
                </svg>
              </div>
              <div class="uk-card-body">
                <p class="uk-margin-small uk-text-muted">{{color.colorName}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>
        Uploads
        <router-link to="/new-project/ind/upload-image">
          <span uk-icon="icon: pencil; ratio: 1.5" class="uk-float-right"></span>
        </router-link>
      </h3>
      <div class="uk-grid uk-child-width-1-2 uk-child-width-1-3@m" uk-grid="masonry: true">
        <div v-for="(file, index) in info.uploadedFiles.files">
          <div class="uk-card uk-card-default uk-card-small">
            <div class="uk-card-media-top">
              <a href="#">
                <img v-if="file.canPreview" :src="file.downloadURL" alt />
                <img v-if="!file.canPreview" src="../../assets/preview-not-available.jpg" alt />
              </a>
            </div>
            <div class="uk-card-body">
              <p class="uk-margin-small uk-text-muted">{{file.originalName | truncate(25)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-width-1-2 uk-align-center">
      <div class="uk-child-width-1-2" uk-grid>
        <div>
          <router-link to="/new-project/ind/upload-image">
            <button class="uk-button uk-button-default uk-width-1-1">Go Back</button>
          </router-link>
        </div>
        <div>
          <button class="uk-button uk-button-primary uk-width-1-1" @click="submitInquiry">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import ProjectsService from "@/services/ProjectsService";
import router from "@/router";

export default {
  name: "IndConfirm",
  data() {
    return {};
  },
  methods: {
    submitInquiry() {
      var self = this;
      ProjectsService.submitIndInquiry(self.info);
      //this.$store.commit('newOrgProject/resetState')
      setTimeout(function() {
        window.location =
          "https://www.knottytie.com/pages/submission-confirmation";
      }, 1000);
    }
  },
  computed: {
    info() {
      return this.$store.state.newIndProject;
    },
    isActive() {
      return this.$store.state.newIndProject.isActive;
    },
    interestedProducts() {
      let products = "";
      let interest = this.info.basicInfo.productInterest;
      for (var key in interest) {
        if (interest[key] == true) {
          products += _.startCase(key) + ", ";
        }
      }
      return products.slice(0, products.length - 2);
    }
  },
  mounted: function() {
    if (!this.isActive) {
      this.$router.push({ name: "CreateIndProject" });
    }
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ind-onboarding/IndConfirm.vue